<template>
  <form
    method="post"
    @submit.prevent="$emit('submit', formData)"
  >
    <h3>
      {{ $t('phrase.register_research') }}
      <small class="text-muted">
        {{ $t('word.general_info').toLowerCase() }}
      </small>
    </h3>

    <div class="card card-body mb-2">
      <div class="row">
        <div
          :class="{'col-md-6': !research, 'col-md-12': research}"
        >
          <div class="h-100 d-flex justify-content-center align-items-center mb-5">
            <div
              v-if="formData.media_file"
              class="card card-body bg-light"
            >
              <div class="d-flex justify-content-between">
                <div>
                  {{ formData.media_file.name }}
                </div>
              </div>

              <v-audio
                :source="formData.media_file.url"
              />
            </div>
            <img
              v-else
              class="img-research-form"
              src="@/common/assets/img/radio.png"
              alt="commercialreview"
            />
          </div>
        </div>
        <div class="col-md-6" v-if="!research">
          <h4>
            <small>
              <i class="fa fa-circle text-cr-red-black"></i>
            </small>

            {{ $t('word.audio_file') }}
          </h4>
          <p class="text-muted">
            {{ $t('sentence.upload_radio_file_instructions') }}
          </p>
          <input
            v-show="false"
            ref="file"
            type="file"
            @change="processFile"
            accept=".mp3,audio/*"
            id="register-commercial-audio-file"
          />

          <v-button
            icon="cloud-upload-alt"
            text="phrase.upload_audio_file"
            @click="$refs.file.click()"
            style-type="secondary"
            size="lg"
            :block="true"
            id="register-commercial-audio-file-submit"
          />
        </div>
      </div>
    </div>

    <transition name="fade">
      <div
        class="card card-extra-info mb-2"
        v-if="formData.media_file"
      >
        <div class="card-body">
          <v-research-form
            :form-data="formData"
            :allow-created-by="allowCreatedBy"
            :allow-published="true"
            :allow-categories="true"
            :errors="errors"
          />
        </div>
        <div class="card-footer d-flex justify-content-end">
          <v-button
            text="phrase.save_and_next"
            id="research-form-submit"
            icon="fa fa-arrow-right"
            type="submit"
            style-type="primary"
            :loader="loader"
          />
        </div>
      </div>
    </transition>
  </form>
</template>

<script>
import Button from '@/common/components/Button.vue';
import { fetchCommercialCategories } from '@/organisation/api';
import { mapGetters } from 'vuex';
import ResearchForm from '@/common/components/research/ResearchForm.vue';
import Audio from '@/common/components/Audio.vue';

export default {
  name: 'ResearchFormRadio',
  components: {
    'v-audio': Audio,
    'v-research-form': ResearchForm,
    'v-button': Button,
  },
  props: {
    research: {
      type: Object,
      required: false,
    },
    allowCreatedBy: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      errors: {},
      loader: { loading: false },
      categories: null,
      formData: {
        title: '',
        description: '',
        organisation: null,
        published_at: null,
        categories: [],
        group_size: 250,
        media_file: null,
      },
    };
  },
  computed: {
    ...mapGetters(['org']),
  },
  methods: {
    processFile(event) {
      const file = event.target.files[0];

      if (file.size / 1024 / 1024 > 5) {
        this.fileErrors = [this.$t('sentence.file_too_large')];
        return;
      }
      this.formData.media_file = null;
      file.url = URL.createObjectURL(file);
      setTimeout(() => {
        this.formData.media_file = file;
        this.$emit('valid-form');
      }, 100);
    },
    async getCommercialCategories() {
      const response = await fetchCommercialCategories();
      this.categories = response.data.map((el) => ({
        id: el.id,
        name: el.name,
      }));
    },
  },
  created() {
    this.getCommercialCategories();
    if (this.research) {
      this.formData = {
        title: this.research.title,
        description: this.research.description,
        organisation: this.research.organisation,
        categories: this.research.commercial.categories,
        published_at: new Date(this.research.commercial.published_at),
        group_size: this.research.group_size,
        media_file: null,
      };

      const path = this.research.commercial.audio_file.split('/');
      this.formData.media_file = {
        url: this.research.commercial.audio_file,
        name: path[path.length - 1],
      };
    }
  },
};
</script>

<style scoped>
.card-extra-info {
  margin-bottom: 80px;
}
</style>
